// extracted by mini-css-extract-plugin
export default {"events_section":"MainEvents_events_section__9oyp4","heading":"MainEvents_heading__ckleA","reveal":"MainEvents_reveal__809BR","events_container":"MainEvents_events_container__JXBfR"};